import { validator } from "@/utils/validator";

export const renewVisaBasicInfoSchema = validator.object().shape({
  conditions: validator.array().of(validator.mixed()).notRequired(),
});
